import { cn } from "../../lib/utils";
import type { CardStatus } from "../../data/types";

interface StatusChipProps {
  status: CardStatus;
  onClick?: () => void;
  size?: "sm" | "md";
  className?: string;
}

const cfg: Record<CardStatus, { label: string; dot: string; bg: string; text: string; ring: string }> = {
  planned: {
    label: "Planned",
    dot: "bg-[#6B6E72]",
    bg: "bg-white/[0.04]",
    text: "text-[#8B8E92]",
    ring: "ring-white/[0.06]",
  },
  in_progress: {
    label: "In Progress",
    dot: "bg-[#266DF0]",
    bg: "bg-[#266DF0]/8",
    text: "text-[#5B8DF4]",
    ring: "ring-[#266DF0]/12",
  },
  blocked: {
    label: "Blocked",
    dot: "bg-red-500",
    bg: "bg-red-500/8",
    text: "text-red-400",
    ring: "ring-red-500/12",
  },
  done: {
    label: "Done",
    dot: "bg-emerald-500",
    bg: "bg-emerald-500/8",
    text: "text-emerald-400",
    ring: "ring-emerald-500/12",
  },
  archived: {
    label: "Archived",
    dot: "bg-[#6B6E72]",
    bg: "bg-white/[0.02]",
    text: "text-[#6B6E72]",
    ring: "ring-white/[0.04]",
  },
};

export function StatusChip({ status, onClick, size = "sm", className }: StatusChipProps) {
  const c = cfg[status];
  const Tag = onClick ? "button" : "span";
  return (
    <Tag
      className={cn(
        "inline-flex items-center gap-[4px] rounded-full font-medium ring-1 ring-inset transition-all duration-[120ms]",
        c.bg, c.text, c.ring,
        size === "sm" ? "px-[7px] py-[1px] text-[11px] leading-[16px]" : "px-[10px] py-[3px] text-[12px] leading-[16px]",
        onClick && "cursor-pointer hover:brightness-125 active:scale-[0.97]",
        className
      )}
      onClick={onClick}
    >
      <span className={cn("h-[5px] w-[5px] rounded-full", c.dot)} />
      {c.label}
    </Tag>
  );
}
